import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RootState } from 'reducers';
import { Status } from 'reducers/enum';

import LoaderOverlay from 'components/LoaderOverlay/LoaderOverlay';
import LicenseList from 'components/LicenseList/LicenseList';
import { useCallback } from 'react';
import Button from 'components/Button/Button';

function LicenseListPage() {
    const navigate = useNavigate();
    const { integrationId } = useParams();
    const retrieveLicensesStatus = useSelector(
        (state: RootState) => state.integrations.retrieveLicensesStatus
    );
    const integration = useSelector(
        (state: RootState) => state.integrations.byId[integrationId]
    );
    const isLoading = retrieveLicensesStatus === Status.Pending;

    const handleBackClicked = useCallback(() => {
        navigate(`/integrations`);
    }, [navigate]);

    return (
        <>
            <LoaderOverlay isLoading={isLoading} />      
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex flex-row justify-content-between align-items-start">
                            <h1 className="msds-text-header-1 msds-text-clear-blue mb-10">Licenses for {integration.name}</h1>
                            <Button color="secondary" className="mb-4 mt-0" type="button" onClick={handleBackClicked}>
                                Back to integrations
                            </Button>
                        </div>
                        {integration?.licenses && (
                            <LicenseList integration={integration} />
                        )}
                    </div>
                </div>
            </div>          
        </>
    );
}

export default LicenseListPage;
